import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from '../../core/components';
import { CustomersListComponent } from './customers-list.component';

@Component({
    selector: 'app-customers',
    templateUrl: './customers.component.html',
    styleUrls: ['../layout/layout.component.scss']
})
export class CustomersComponent extends BaseComponent implements OnInit {
    @ViewChild('customersList') customersList: CustomersListComponent;
    public isAdminOrUserEditor: boolean;
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        public activeModal: NgbActiveModal,
        private location: Location) {
        super(router);
    }

    public ngOnInit() {
        let currentUser = super.currentLoggedUser();
        let currentRole = currentUser.role;

        let siteId = +localStorage.getItem('LoanscurrentSiteId')

        if (currentRole === 'admin') {
            this.isAdminOrUserEditor = true;
            this.customersList.isAdminOrUserEditor = true;
            this.customersList.loadDataByAccountId(currentUser.accountId, siteId);
        }
        else if (currentRole === 'user') {
            this.isAdminOrUserEditor = false;
            this.customersList.loadDataByAccountId(currentUser.accountId, siteId);
        }
        else if (currentRole === 'superadmin') {
            this.isAdminOrUserEditor = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/customers/customers.component.ts